module.exports = __webpack_public_path__ + "img/4right-n-10960a5b.png";